import * as types from 'store/actions/types';
import produce from 'immer';

export const INITIAL_STATE = {
	edit: {},
	isLoaded: true,
	error: false
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ****************** CLEAR STATE ******************
			case types.CLEAR_STATE:
				return { ...INITIAL_STATE };
			// ****************** FETCH PROMOTION USERS LIST ******************
			case types.FETCH_PROMOTION_USERS_LIST_LOADING:
				draft.isLoaded = false;
				draft.error = false;
				draft.edit = {};
				return;

			case types.FETCH_PROMOTION_USERS_LIST_SUCCESS:
				draft.edit = action.payload;
				draft.isLoaded = true;
				return;

			case types.FETCH_PROMOTION_USERS_LIST_ERROR:
				draft.isLoaded = true;
				draft.error = true;
				return;

			default:
				return state;
		}
	});
